<template>
	<div class="one-row">
		<div class="box form-box">
			<span class="box-title title-forgot-password">{{ $t('forgotten_password_box_title') }}</span>
			<form class="form" @submit.prevent="handleSubmit">
				<span class="box-subtitle" :class="$i18n.locale === 'ar' ? 'box-subtitle-right' : ''">{{ $t('forgotten_password_email') }}</span>
				<TextInputField 
							:modelValue="email"
							@update:modelValue="email = $event"
							:field-type="'email'"
							name="email"
							:placeholder="''" 
							:has-error="email_error"
							:is-required-value="true"
						/>
				<!-- <input class="form-item" type="email" name="email" :placeholder="$t('forgotten_password_email')" v-model="email" :class="(email_error ? 'has-error' : '')"> -->
				<!-- <button class="green-button submit-button animated-button" :class="(!isDisabled ? 'unactive' : '')" type="submit" :disabled="loading">
					<span class="loading" v-if="loading"></span>
					<span v-else>{{ $t('forgotten_password_send') }}</span>
				</button> -->
				<SubmitButton :label="$t('forgotten_password_send')" :isLoading="loading" />
				<!-- <span class="form-small-text">
					<router-link to="/login" class="btn">{{ $t('forgotten_password_back_to_login') }}</router-link>
				</span> -->
			</form>
		</div>
	</div>
</template>
<script>

import TextInputField from '../components/TextInputField.vue';
import SubmitButton from '../components/SubmitButton.vue';
import AuthService from '../services/auth.service';

	export default {
  components: {
	"TextInputField": TextInputField,
	"SubmitButton": SubmitButton,
    },
		data() {
			return {
				email: '',
				email_error: false,
				loading: false
			}
		},

		computed: {
			isDisabled: function() {
				if (this.email != '') {
					return true;
				}

				return false;
			}
		},

		methods: {
			handleSubmit: function() {
				var error = this.checkField();

				if (!error) {
					AuthService.fogottenPassword(this.email)
						.then((response) => {
							if (response.status == 200) {
								this.$parent.showFlashMessage(this.$t('forgotten_password_sucess'));
								this.$router.push({name: 'login'}).catch(()=>{});
							}
							this.loading = false;
						}).catch((error) => {
							this.handleErrors(error.response);
							this.loading = false;
						});
				}
			},

			checkField: function() {
				var has_error = false

				if (this.email == '') {
					this.has_error = true;
					this.email_error = true;
				}

				return has_error;
			},

			handleErrors: function(response) {
				if (response.status == 400) {
					if (response.data.code == 1) {
						return this.$parent.showFlashMessage(this.$t('forgotten_password_error_empty_email'));
					}

					if (response.data.code == 2) {
						return this.$parent.showFlashMessage(this.$t('forgotten_password_error_invalid_email'));
					}

					if (response.data.code == 3) {
						return this.$parent.showFlashMessage(this.$t('forgotten_password_error_error_updatting_email'));
					}
				}

				if (response.status == 404) {
					return this.$parent.showFlashMessage(this.$t('forgotten_password_error_error_email_not_found'));
				}
			}
		},
	}
</script>
<style lang="css">
.title-forgot-password {
	padding-block: 20px;
}
</style>